// Activation-related constants
export const ACTIVATION = {
  // Page titles and headers
  ACTIVATING_ACCOUNT: 'Activating Your Account',
  RESET_PASSWORD: 'Reset Password In Progress',
  ACCOUNT_ACTIVATION_FAILED: 'Account Activation Failed',
  FORGOT_PASSWORD_FAILED: 'Reset Password Action Failed',
  ACCOUNT_ACTIVATED: 'Account Activated!',
  FORGOT_PASSWORD_SUCCESS: 'Password Successfully Changed!',

  // Loading states
  ACTIVATING_SUBHEADING: 'Please wait while we activate your account...',
  SETTING_PASSWORD: 'Setting Password...',

  // Success messages
  SUCCESSFUL_LOGIN: 'You have been successfully logged in.',
  ACCOUNT_ACTIVATED_MESSAGE: 'Your account has been successfully activated. Redirecting to login...',
  FORGOT_PASSWORD_SUCCESS_MESSAGE: 'Your password has been successfully changed. Redirecting to login...',

  // Error messages
  MISSING_ACTIVATION_TOKEN: 'Missing activation token.',
  NO_STATE_TOKEN: 'No state token available. Please refresh the page and try again.',
  FAILED_TO_AUTHENTICATE: 'Failed to authenticate with Okta',
  FAILED_TO_SET_PASSWORD: 'Failed to set password. Please try again.',
  NO_SESSION_TOKEN: 'No session token available for OAuth flow',
  USERNAME_NOT_AVAILABLE: 'Username not available from Okta response. Please implement proper username extraction.',
  MFA_ENROLLMENT_REQUIRED: 'MFA enrollment required but no state token available',

  // Help and support
  HELP_MESSAGE: 'The information provided cannot be found. Please call 800-251-8736 or email the help center for assistance in verifying your information.',
  CALL_HELP: 'Call 800-251-8736',
  EMAIL_HELP: 'Email Help Center',
  RETURN_TO_LOGIN: 'Return to Login',
  GO_TO_LOGIN: 'Go to Login',

  // Password form
  NICE_TO_SEE_YOU: 'Nice to See You Again',
  ENTER_PASSWORD: 'Enter your password',
  PASSWORD_DESCRIPTION: 'Keep your account safe with a secure password.',
  RESET_PASSWORD_HEADING: 'Set Your New Password',
  RESET_PASSWORD_DESCRIPTION: 'Choose a strong password to secure your account.',
  RESET_PASSWORD_SUB_DESCRIPTION: 'Regain access to your account by resetting your password, following the provided guidelines.',
  PASSWORD_LABEL: 'Password',
  CONTINUE: 'Continue',

  // MFA setup
  CHOOSE_MFA_METHOD: 'Choose your multi-factor authentication method',
  MFA_DESCRIPTION: 'Select your preferred MFA method to complete account activation.',
  SET_UP_MFA: 'Set Up MFA',
  SKIP_FOR_NOW: 'Skip for Now',

  // UI elements
  WELCOME_FALLBACK: 'Welcome',
  BUTTON_TYPE: 'button',
  EYE_SLASH_ICON: 'eye-slash',
  EYE_ICON: 'eye',
  FAL_ICON_SET: 'fal',
  CHECK_CIRCLE_ICON: 'check-circle',
  EXCLAMATION_TRIANGLE_ICON: 'exclamation-triangle',

  // Links and paths
  PHONE_LINK: 'tel:800-251-8736',
  EMAIL_LINK: 'mailto:help@wyndhamdestinations.com',
  LOGIN_PATH: '/login',

  // MFA factor descriptions
  MFA_FACTORS: {
    CALL: {
      LABEL: 'Call',
      DESCRIPTION: 'Receive a phone call with a verification code',
    },
    EMAIL: {
      LABEL: 'Email',
      DESCRIPTION: 'Receive an email with a verification code',
    },
    SMS: {
      LABEL: 'SMS',
      DESCRIPTION: 'Receive a text message with a verification code',
    },
  },
} as const

// // Export individual constants for easier imports
// export const {
//   ACTIVATING_ACCOUNT,
//   RESET_PASSWORD,
//   ACCOUNT_ACTIVATION_FAILED,
//   FORGOT_PASSWORD_FAILED,
//   ACCOUNT_ACTIVATED,
//   FORGOT_PASSWORD_SUCCESS,
//   ACTIVATING_SUBHEADING,
//   SETTING_PASSWORD,
//   SUCCESSFUL_LOGIN,
//   ACCOUNT_ACTIVATED_MESSAGE,
//   FORGOT_PASSWORD_SUCCESS_MESSAGE,
//   MISSING_ACTIVATION_TOKEN,
//   NO_STATE_TOKEN,
//   FAILED_TO_AUTHENTICATE,
//   FAILED_TO_SET_PASSWORD,
//   NO_SESSION_TOKEN,
//   USERNAME_NOT_AVAILABLE,
//   MFA_ENROLLMENT_REQUIRED,
//   HELP_MESSAGE,
//   CALL_HELP,
//   EMAIL_HELP,
//   RETURN_TO_LOGIN,
//   GO_TO_LOGIN,
//   NICE_TO_SEE_YOU,
//   ENTER_PASSWORD,
//   PASSWORD_DESCRIPTION,
//   PASSWORD_LABEL,
//   CHOOSE_MFA_METHOD,
//   MFA_DESCRIPTION,
//   SET_UP_MFA,
//   SKIP_FOR_NOW,
//   WELCOME_FALLBACK,
//   BUTTON_TYPE,
//   EYE_SLASH_ICON,
//   EYE_ICON,
//   FAL_ICON_SET,
//   CHECK_CIRCLE_ICON,
//   EXCLAMATION_TRIANGLE_ICON,
//   PHONE_LINK,
//   EMAIL_LINK,
//   LOGIN_PATH,
//   MFA_FACTORS,
// } = ACTIVATION
